import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core'
import { messageSidebarAnimation } from '@tv3/animations/message-sidebar.animation'

@Component({
  selector: 'app-sidebar-expansion-panel',
  templateUrl: './sidebar-expansion-panel.component.html',
  styleUrls: ['./sidebar-expansion-panel.component.scss'],
  animations: [messageSidebarAnimation],
})
export class SidebarExpansionPanelComponent {
  @HostBinding('class') classes = 'clearfix default-box-holder'

  @Input() header: string
  @Input() hasEdit = false
  @Input() canEdit = true

  @Output() edit = new EventEmitter()

  isExpanded = true
  expanded: string

  onToggle() {
    this.isExpanded = !this.isExpanded
    this.expanded = this.isExpanded ? 'active' : 'inactive'
  }

  get tooltipText() {
    if (this.hasEdit) {
      return `Edit ${(this.header + '').toLowerCase()}`
    } else {
      return ''
    }
  }
}
